import { render, staticRenderFns } from "./Mergers&Acquisitions.vue?vue&type=template&id=7e141944&"
import script from "./Mergers&Acquisitions.vue?vue&type=script&lang=ts&"
export * from "./Mergers&Acquisitions.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports